import { date, TESTING_LEVEL_NAMES, type TestingLevel, type Terms } from './model.ts';
import { DomainScopeCards } from './DomainScopeCards.tsx';
import styles from './authorization.module.css';

export function LetterDetails({ terms }: { terms: Terms }) {
  return (
    <dl className={styles.details}>
      <div>
        <dt>Organization · verified domain</dt>
        <dd>
          {terms.organization} · {terms.domain}
        </dd>
      </div>
      <div>
        <dt>Authorization</dt>
        <dd>{terms.engagement}</dd>
      </div>
      <div>
        <dt>Authorizer</dt>
        <dd>
          {terms.authorizer.name} · {terms.authorizer.role}
          <br />
          {terms.authorizer.email}
        </dd>
      </div>
      <div>
        <dt>Authority declared by the authorizer</dt>
        <dd>{terms.authorizer.authority}</dd>
      </div>
      <div>
        <dt>Included domain scope</dt>
        <dd>
          <DomainScopeCards domains={terms.domains} domain={terms.domain} />
        </dd>
      </div>
      <div>
        <dt>Excluded hosts</dt>
        <dd>{terms.exclusions.join(', ') || 'None declared'}</dd>
      </div>
      <div>
        <dt>Testing level</dt>
        <dd>{TESTING_LEVEL_NAMES[terms.testingLevel as TestingLevel] ?? terms.testingLevel}</dd>
      </div>
      <div>
        <dt>Testing window · displayed in your local time</dt>
        <dd>
          {date(terms.startsAt)} → {date(terms.endsAt)}
          <br />
          Recorded timezone: {terms.timezone}
          <br />
          UTC: {terms.startsAt} → {terms.endsAt}
        </dd>
      </div>
      <div>
        <dt>Limits</dt>
        <dd>
          {terms.limits.requestsPerSecond} requests/second · {terms.limits.concurrency} concurrent
          requests
        </dd>
      </div>
      <div>
        <dt>Prohibited operations</dt>
        <dd>{terms.limits.prohibited.join(', ') || 'None beyond the listed scope'}</dd>
      </div>
      {terms.impactAccepted && (
        <div>
          <dt>Impact acceptance</dt>
          <dd>
            The authorizer accepted in writing that testing may disrupt or damage the included
            hosts.
          </dd>
        </div>
      )}
      <div>
        <dt>Owner’s provider policy</dt>
        <dd>
          {terms.exclusive
            ? 'Traceira is the only authorized testing provider. Other providers must obtain separate permission from the owner.'
            : 'Traceira is an authorized testing provider.'}
          <br />
          Valid until {date(terms.policyEndsAt)} unless revoked.
        </dd>
      </div>
    </dl>
  );
}
